<template>
  <div class="auth">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Auth'
}
</script>

<style lang="scss" scoped>
  .auth {
    width: 100%;
    height: 100%;
    background: linear-gradient(235deg, rgb(46,196,182) 0%, rgb(22,72,113) 100%);
    position: fixed;
    overflow: scroll;
    z-index: 4;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
